"use strict";

import Dom from "common/Dom";
import chosenJs from "chosen-js";
export const initSelects = function initSelects() {
  $(Dom.customSelect).chosen({
    disable_search_threshold: 10,
  });
};
export const mobilePlaceholders = function mobilePlaceholders() {
  $(Dom.mobilePlaceholder).each(function () {
    var placeholderText = $(this)
      .closest($(Dom.customSelect))
      .attr("data-placeholder");
    $(this).text(placeholderText);
  });
};
